import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'

import type { SoftwareAssuranceWorkflowController } from '@/hooks/workflow/useSoftwareAssuranceWorkflow'

interface CategorizationStepSectionProps {
  workflow: SoftwareAssuranceWorkflowController
}

export function CategorizationStepSection({ workflow }: CategorizationStepSectionProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div>
          <h4 className="text-sm font-semibold">System Categorization</h4>
          <p className="text-xs text-muted-foreground">
            Review CNSSI 1253 CIA levels and rationale. Edit in the Profile step.
          </p>
        </div>
        {workflow.selectedMissionId && (
          <Button
            variant="outline"
            onClick={() =>
              workflow.setCurrentStep(workflow.steps.findIndex((step) => step.id === 'profile'))
            }
          >
            Edit in Profile
          </Button>
        )}
      </div>
      <div className="grid gap-3 rounded-lg border border-border p-4 bg-muted/30">
        {workflow.missionProfile ? (
          <>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Confidentiality</span>
              <Badge variant="outline">{workflow.missionProfile.cia_confidentiality || 'Unspecified'}</Badge>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Integrity</span>
              <Badge variant="outline">{workflow.missionProfile.cia_integrity || 'Unspecified'}</Badge>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Availability</span>
              <Badge variant="outline">{workflow.missionProfile.cia_availability || 'Unspecified'}</Badge>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Rationale</p>
              <p className="text-sm">{workflow.missionProfile.cia_rationale || 'No rationale captured yet.'}</p>
            </div>
          </>
        ) : workflow.selectedMissionId ? (
          <p className="text-sm text-muted-foreground">
            Complete the Profile step first to set CIA categorization.
          </p>
        ) : (
          <p className="text-sm text-muted-foreground">Select a mission to view categorization.</p>
        )}
      </div>
    </div>
  )
}
